
















    import { Component, Vue } from 'vue-property-decorator';

    @Component({
		components: {}
	})
	export default class Product extends Vue {
        private aiclass: any = 'https://xiaoheketang.knowbox.cn';
        private program: any = 'https://xiaoheketang.knowbox.cn';

        private jump() {
            window.open('https://xiaoheketang.knowbox.cn/download');
        }
    }
